<template>
  <transition name="fade">
    <div class="cert-page">
      <section class="main-container">
        <div class="title">ISO certificate</div>
        <div class="iso-img"><img src="../assets/ISO9001.png"></div>
         <div class="iso-img"><img src="../assets/ISO14001.png"></div>
      </section>
    <GPFooter />
    </div>
  </transition>
</template>
<style lang="scss">
    .cert-page {
      .iso-img{
        text-align: center;
        margin: 0 auto;
        img{
         width: 50vw;
        }
      }
        padding-top: 4.3vw;
        .title {
          text-align: center;
          font-size: 3vw;
          margin: 0;
          font-family: 'Pingfang-Bold';
        }
        .content {
          margin: 3vw auto;
          font-size: 1.2vw;
          line-height: 2vw;
          color: #fff;
        }
    }
    @media (max-width: 1024px) {
      .cert-page {
        padding-top: 12vw;
        .title {
          font-size: 6vw;
          font-weight: bold;
          line-height: 8vw;
        }
        .content {
          font-size: 4vw;
          line-height: 8vw;
        }
      }
    }
</style>

<script>
export default {
  name: 'Certpage',
  props: {
  },
  data () {
    return {}
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CertPage.vue